// Product variant title handler
document.addEventListener('DOMContentLoaded', function() {
  // Hide any variant titles containing "DEFAULT TITLE" as fallback
  const allVariantTitles = document.querySelectorAll('.variant-title-display');
  allVariantTitles.forEach(title => {
    const titleText = title.textContent.trim().toUpperCase();
    if (titleText === 'DEFAULT TITLE' || titleText === 'DEFAULT' || titleText === '') {
      title.style.display = 'none';
    }
  });

  const products = document.querySelectorAll('.product-container');

  products.forEach(product => {
    const productId = product.id.split('-')[1];
    const colorCircles = product.querySelectorAll('.color-circle');
    const titles = product.querySelectorAll('.variant-title-display');
  
    colorCircles.forEach(circle => {
      circle.addEventListener('click', function() {
        const variantId = this.getAttribute('data-variant-id');
        const variantName = this.getAttribute('data-variant-name');

        // Don't show if variant name is "DEFAULT TITLE"
        if (variantName && variantName.trim().toUpperCase() === 'DEFAULT TITLE') {
          return;
        }

        titles.forEach(title => {
          title.style.display = 'none';
        });

        const titleDisplay = product.querySelector(`#variant-title-${productId}-${variantId}`);
        if (titleDisplay) {
          // Apply truncation
          const displayText = truncateText(variantName, 55);
          // Double-check it's not "DEFAULT TITLE"
          if (displayText.trim().toUpperCase() !== 'DEFAULT TITLE') {
            titleDisplay.textContent = displayText;
            titleDisplay.style.display = 'block';
          } else {
            titleDisplay.style.display = 'none';
          }
        }
      });
    });
  });

  function truncateText(text, maxLength) {
    if (!text) return '';
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  }
});

